// extracted by mini-css-extract-plugin
export default {"container":"PZ-z","heading":"QZ-z","links":"RZ-z","copy":"SZ-z","subCopy":"TZ-z","linksLeft":"UZ-z","linksCenter":"VZ-z","linksRight":"WZ-z","link":"XZ-z","onlyLink":"YZ-z"};